import AccountInfo from "@/modules/AccountInfo";
import routes from "@/routes";

const AccountInfoRoutes = {
  element: <AccountInfo />,
  path: routes.ACCOUNT_INFO,
};

export default AccountInfoRoutes;
